import { colors } from 'theme';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { InfoText, InfoWrapper } from '../DeclarationInformation.styles';

export const Wrapper = styled(InfoWrapper)`
    min-width: 0;
`;

export const JobList = styled.ul`
    display: flex;
    align-items: flex-start;
    flex-wrap: wrap;
    gap: 0.8rem;
    margin: 0;
    padding: 0;
    min-width: 0;
    list-style: none;
    width: 100%;
`;

export const JobItem = styled.li`
    display: flex;
    align-items: center;
    gap: 0.8rem;
    /* min-width: 0; */
`;

export const JobLink = styled(Link)`
    display: block;
    height: min-content;
    /* min-width: 0; */
`;

export const JobReference = styled(InfoText)`
    display: block;
    color: ${colors.brand6};

    &:hover {
        text-decoration: underline;
    }
`;
